
<div class="r-container" fxLayout="row" fxLayoutAlign="center center">
  {{data}}
</div>
